import { defineStyle } from "@chakra-ui/react";

//Subject Selector Styles

export const SubjectSelectorStyles = (
  isSideNav,
  isUnlocked,
  selectedSubtopic,
  topic,
  isMobile
) => {
  return {
    mainContainer: defineStyle({
      cursor: "pointer",
      width: "100%",
      backgroundColor: "white.900",
    }),
    sideNavHeader: defineStyle({
      fontFamily: "Poppins, Mobile/xl_semibold",
      fontWeight: "600",
      fontSize: "20px",
      lineHeight: "30px",
      color: "black.300",
      marginBottom: "10px",
    }),
    subtopicContainer: defineStyle({
      alignItems: "flex-start",
      width: "100%",
      gap: 2,
    }),
    subtopicBox: defineStyle({
      width: "100%",
    }),
    subtopicHeaderBox: defineStyle({
      overflow: "hidden",
      opacity: isUnlocked ? 1 : 0.5,
      backgroundColor: "white.900",
      // _hover: "none",
      width: "100%",
      height: "48px",
      fontSize: ["sm", "md", "lg"],
      paddingX: [2, 3, 5, 5],
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      color:
        selectedSubtopic?.id !== topic?.subtopicId ? "indigo.900" : "white.900",
      _hover: { bgColor: ["transparent", "transparent", "#FFDFDB"] },
      WebkitTapHighlightColor: "transparent",
    }),
    progressStatusIcon: defineStyle({
      display: "flex",
      alignItems: "center",
    }),
    subtopicTitleBox: defineStyle({
      height: "fit-content",
      overflow: "hidden",
      flex: 1,
    }),
    subtopicTitle: defineStyle({
      flex: 1,
      textAlign: "left",
      fontSize: { base: "12px", md: "14px", lg: "14px" },
      paddingLeft: "12px",
      paddingTop: "0px",
      lineHeight: { base: "16px", md: "18px", lg: "18px" },
      fontWeight: "400",
      marginLeft: "0px",
      fontFamily: "Text-xs/Regular",
      color: "navyBlue.100",
    }),
    taskListBox: defineStyle({
      maxWidth: "100%",
      borderRadius: "8px",
      margin: isMobile || isSideNav ? "8px 20px 8px 12px" : "8px 32px 8px 32px",
      padding: "8px 12px 12px 12px",
      backgroundColor: "white.900",
      borderWidth: isMobile || isSideNav ? "0px" : "1px",
      borderColor: isMobile || isSideNav ? "none" : "grey.100",
    }),
    progressItems: defineStyle({
      display: "flex",
      justifyContent: "center",
      alignItems: isMobile && !isSideNav ? "start" : "center",
    }),
    bottomLine: defineStyle({
      width: { base: "94%", md: "96%", lg: "96%" },
      height: "1px",
      bgColor: "purple.100",
      ml: "auto",
      mt: "8px",
    }),
  };
};
